<template>
  <layouts-guest>
    <base-shadow-card :title="t('forgot_password.title')">
      <p class="mb-4">{{ t('forgot_password.send_link_messeage') }}</p>
      <form @submit.prevent="onSubmit">
        <div class="mb-4">
          <label for="email" class="form-label">{{ t('word.email') }}</label>
          <input
            v-model="email"
            id="email"
            name="email"
            type="email"
            :placeholder="t('word.email')"
            :class="`form-input ${errors['email'] ? '!border-red-500' : ''}`"
          >
          <p class="form-error-text">{{ errors['email'] }}</p>
        </div>
        <div class="flex items-center justify-between pt-2">
          <button @click="router.back()" type="button" class="bg-gray-300 hover:bg-gray-400 text-gray-800 py-1.5 px-4 rounded">
            {{ t('word.back') }}
          </button>
          <base-form-submit :disabled="btnDisabled" />
        </div>
      </form>
    </base-shadow-card>
  </layouts-guest>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { axios } from '@/plugins/axios'
import { useRouter } from 'vue-router'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { useStore } from '@/store/index'
import { ALERT_COLORS } from '@/store/base'

import LayoutsGuest from '@/layouts/Guest.vue'
import BaseShadowCard from '@/components/BaseShadowCard.vue'
import BaseFormSubmit from '@/components/BaseFormSubmit.vue'

export default defineComponent({
  components: { LayoutsGuest, BaseShadowCard, BaseFormSubmit },
  setup() {
    const { t } = useI18n()
    const router = useRouter()
    const store = useStore()
    const btnDisabled = ref(false)

    const schema = yup.object({
      email: yup.string().required().email().max(255),
    })
    const { handleSubmit, errors } = useForm({ validationSchema: schema })
    const { value: email } = useField<string>('email')

    const onSubmit = handleSubmit(values => {
      btnDisabled.value = true
      axios
        .post('/forgot-password', values)
        .then(() => {
          store.commit('base/setAlertMessages', { messages: [t('forgot_password.success')], persistent: true, color: ALERT_COLORS.info })
          router.push('/login')
        })
        .finally(() => btnDisabled.value = false)
    })

    return {
      t,
      errors,
      email,
      onSubmit,
      btnDisabled,
      router
    }
  },
})
</script>
